import { useEffect, useState } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { StudyService } from "../../model/study";
import { useDispatch, useSelector } from "react-redux";
import { encode } from "js-base64";
import {
  ConvertJson2Date,
  CreateTooltip,
  DicomStatusHeader,
  FileUploadStatus,
  GetHeaderStyle,
  GetImageStduyStatus,
  getCellStyle,
} from "../../core/Helper";
import BootstrapTable from "react-bootstrap-table-next";
import {
  GetThaiDateTime,
  GetThaiDateTimeCheckToday,
  ThaiDate,
} from "../../core/ThaiDate";
import styled from "styled-components";
import { AiOutlineHistory } from "react-icons/ai";
import { MainContainer } from "../components/Styled";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { FaAccusoft, FaCheck } from "react-icons/fa";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { BiRefresh } from "react-icons/bi";
import RadioResultPastCheck from "../radi/RadioResultPastCheck";
import PopupOpenRemoteFile from "../radi/PopupOpenRemoteFile";
import ConfirmDialogB from "../components/ConfirmDialogB";
import { setReminder } from "../../features/UserActions";
import { TbHistory, TbTimelineEvent } from "react-icons/tb";
import { MyModal } from "../../features/RadConnStyle";

export default function StudyHistoryTracking(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [state, setState] = props.winState;
  const defaultData = { studyInfo: [], rows1: [], rows2: [], rows3: [] };
  const [data, setData] = useState(defaultData);
  const [studySubItem, setSubItem] = useState(null);
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });
  const dispatch = useDispatch();
  useEffect(() => {
    if (state?.show) {
      getData();
      getHistory();
    }
    return () => {
      setData(defaultData);
    };
  }, [state?.show]);

  const handleClose = () => {
    state.action && state?.action();
    setState({ show: false });
  };

  const getData = async () => {
    if (!state.data) return;

    let ret = await StudyService.GetStudyHistoryTracking({
      StudyInfo: { pacsStudyId: state?.data?.PacsStudyId },
      UserInfo: encode(JSON.stringify(userDetail)),
    });
    if (ret) {
      //console.log(ret);
      setData({
        studyInfo: ret?.studyInfo,
        rows1: ret?.rows1 ?? [],
        rows2: ret?.rows2 ?? [],
        rows3: ret?.rows3 ?? [],
      });
    } else {
      setData(defaultData);
    }
  };

  const [hist, setHist] = useState([]);

  const getHistory = async () => {
    let hi = await StudyService.GetHistory({
      StudyInfo: {
        pacs_study_id: state?.data?.PacsStudyId,
        study_instance_uid: state?.data?.study_instance_uid,
      },
      UserInfo: userDetail,
    });
    setHist(hi);
  };

  const [loadingHist, setLoadingHist] = useState(false);

  const [fileOpener, setFileOpener] = useState({ show: false });

  const downloads = async (row) => {
    let ret = await StudyService.CheckFileReadyToDownload({ StudyInfo: row });

    if (ret.result == true) {
      const url =
        process.env.REACT_APP_API +
        "api/studyinfo/getstudy?suid=" +
        row.study_instance_uid;
      const link = document.createElement("a");
      link.target = "_self";
      link.download = link.href = url;
      link.click();
    } else {
      setConfirm({
        show: true,
        title: (
          <div
            style={{
              background: "#000000",
              color: "#11f811",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div>ไม่พบไฟล์ Zip คนไข้ที่ต้องการ download</div>
            <div>
              ท่านต้องการแจ้งเตือนเพื่อ{" "}
              <span style={{ color: "#ffffff" }}> Upload ภาพใหม่ </span>หรือไม่
            </div>
            <div>กรุณายืนยัน</div>
          </div>
        ),
        action: (e) => {
          if (e === true) {
            requestReUpload(row);
          }
        },
      });
    }
  };

  const sendRequestImage = (row, fileStatus) => {
    setFileOpener({
      show: true,
      imageOnServerStatus: row?.upload_status, // 1: uploaded, 3: deleted
      action: (res) => {
        if (row.upload_status == FileUploadStatus.Uploaded) {
          //download file...
          downloads(row);
        } else if (row.upload_status == FileUploadStatus.Deleted) {
          // ขอ upload
          requestReUpload(row);
        }
        //elseif(row.upload_status == FileUploadStatus.WaitReUpload) {}
      },
    });
  };

  const requestReUpload = async (row) => {
    let ret = await StudyService.RequestOldStudyFile({
      StudyInfo: {
        pacs_study_id: row.pacs_study_id,
      },
      UserInfo: { userid: userDetail.userid },
    });

    if (ret != null) {
      dispatch(
        setReminder({
          show: true,
          message: "แจ้งการขอ upload ไฟล์ไปที่ Server เรียบร้อยแล้ว",
          type: "success",
        })
      );
      getHistory();
    }
  };
  const formatStatus = (cell, row) => {
    return <GetImageStduyStatus id={row.action_id} />;
  };
  const fontName = "tahoma";
  const fontSize = "11px";
  const histCols = [
    {
      dataField: "pacs_study_id",
      hidden: true,
    },
    {
      dataField: "study_date",
      text: "วันที่",
      // sort: true,
      headerStyle: GetHeaderStyle("90px"),
      style: getCellStyle("left", null, fontSize, fontName),
      editable: true,
      formatter: (cell, row) => {
        return <ThaiDate dateValue={cell} />;
      },
    },
    {
      dataField: "modality",
      text: "Modality",
      // sort: true,
      headerStyle: GetHeaderStyle("80px", "left"),
      style: getCellStyle("center", null, fontSize, fontName),
      editable: true,
    },
    {
      dataField: "item_name",
      text: "รายการ",
      // sort: true,
      headerStyle: GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    {
      dataField: "brchshort",
      text: "ส่งจาก",
      // sort: true,
      headerStyle: GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    {
      dataField: "physician",
      text: "อ่านผลโดย",
      headerStyle: GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    {
      dataField: "action_event",
      text: "สถานะ",
      headerStyle: () => GetHeaderStyle("140px"),
      style: getCellStyle("left", null, fontSize, fontName),
      formatter: formatStatus,
      align: "center",
    },
    {
      dataField: "upload_stutus",
      text: (
        <RefrshButtonContainer>
          {CreateTooltip(
            "Click to Refresh",
            <RefreshButton onClick={() => getHistory()}>
              {loadingHist ? (
                <Oval
                  style={{ height: "20px", width: "20px", color: "#14f539" }}
                />
              ) : (
                <>
                  File
                  <BiRefresh size={20} />
                </>
              )}
            </RefreshButton>,
            "top"
          )}
        </RefrshButtonContainer>
      ),
      headerStyle: GetHeaderStyle("100px"),
      style: getCellStyle("center"),
      editable: false,
      formatter: (cell, row) => {
        return CreateTooltip(
          "Download",
          DicomStatusHeader(cell, row, null, sendRequestImage, "top")
        );
      },
    },
  ];

  const [selectItem, setSelectItem] = useState(null);
  const defaultShowOld = { show: true, action: (e) => {} };
  const [showOld, setShowOld] = useState(null);
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setSelectItem(row);
    },
    onDoubleClick: (e, row, rowIndex) => {
      setShowOld(defaultShowOld);
    },
  };

  const selectRow = {
    mode: "radio",
    clickToSelect: false,
    // classes: "row-h-over-selected",
    hideSelectColumn: true,
    selected: [data?.studyInfo?.pacs_study_id],
    style: {
      // backgroundImage: "linear-gradient(0deg, #3e3ea1 0%, #310f66 80% )",
      backgroundImage:
        "linear-gradient(0deg, var(--table-selected-backcolor) 0%, var(--table-selected-backcolor) 80% )",
    },
  };

  return (
    <MyModal fullscreen centered show={state.show}>
      <Modal.Header
        closeButton
        onHide={handleClose}
        style={{ background: "black", alignItems: "start" }}
      >
        <HeaderContainer>
          <AiOutlineHistory
            style={{ marginRight: "5px" }}
            color="#0bf057"
            size={40}
          />
          <LabelSpan style={{ color: "#b0f70b" }}>
            {" "}
            ประวัติการดำเนินการคนไข้เข้ารับบริการ
          </LabelSpan>
          <PatientContainer>
            <LabelSpan>ชื่อคนไข้:</LabelSpan>

            <ItemSpan>{data?.studyInfo[0]?.patients_name}</ItemSpan>

            <LabelSpan>HN:</LabelSpan>
            <ItemSpan>{data?.studyInfo[0]?.patientid ?? "-"}</ItemSpan>

            <LabelSpan>เพศ:</LabelSpan>
            <ItemSpan>
              {data?.studyInfo[0]?.patients_sex == "M" ? "ชาย" : "หญิง"}
            </ItemSpan>

            <LabelSpan>อายุ</LabelSpan>
            <ItemSpan>
              {data?.studyInfo[0]?.patients_age
                ?.replace(/^0+/g, "")
                ?.replace(/[y,Y]/g, " ปี")
                ?.replace(/[m,M]/, " เดือน")}
            </ItemSpan>
          </PatientContainer>
          <PatientContainer>
            <LabelSpan>Study Description</LabelSpan>

            <ItemSpan>{data?.studyInfo[0]?.study_description}</ItemSpan>
          </PatientContainer>
        </HeaderContainer>
      </Modal.Header>
      <Modal.Body style={{ background: "black" }}>
        <Tabs defaultActiveKey="timeline" fill={true}>
          <Tab
            eventKey="timeline"
            title={
              <span>
                <TbTimelineEvent color="#ffff00" size={20} />
                Time-Line
              </span>
            }
          >
            {/* <TableTitle>ประวัติการส่งอ่าน</TableTitle> */}

            <TimelineContainer>
              <VerticalTimeline>
                {data?.rows1?.map((elem, i) => {
                  return (
                    <VerticalTimelineElement
                      key={elem?.id ?? i}
                      date={
                        <div style={{ paddingInline: "10px" }}>
                          <GetThaiDateTimeCheckToday
                            dateValue={elem?.created ?? new Date()}
                          />
                        </div>
                      }
                      textClassName="timeline-text-style"
                      iconClassName="timeline-icon-style"
                      // contentStyle={{ background: "#222222", border: "none" }}
                      iconStyle={{ background: "#121212", color: "#2af506" }}
                      icon={<FaCheck />}
                    >
                      <div className="vertical-timeline-element-title">
                        <ParaInfo>{elem?.action_name}</ParaInfo>
                        <ParaInfo>
                          <span style={{ color: "#847f7f" }}>โดย:</span>
                          <i style={{ color: "#109af0" }}>{elem?.staff}</i>
                        </ParaInfo>
                      </div>
                    </VerticalTimelineElement>
                  );
                })}
              </VerticalTimeline>
            </TimelineContainer>
          </Tab>
          <Tab
            eventKey="history"
            title={
              <span>
                <TbHistory color="#ffff00" size={20} />
                ประวัติการอ่านผล
              </span>
            }
          >
            <BootstrapTable
              // ref={refTb}
              bootstrap4
              keyField="pacs_study_id"
              // data={data?.studyHistory != null ? data.studyHistory : []}
              data={hist}
              rowClasses={"table-next-rows-style"}
              columns={histCols}
              striped
              hover
              condensed
              headerWrapperClasses="table-radi-result-wrapper"
              headerClass="table-radi-result-header"
              wrapperClasses="table-radi-result-wrapper"
              bordered={true}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   beforeSaveCell: actionPriceChange,
              // })}
              selectRow={selectRow}
              rowEvents={rowEvents}
            />
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>

      <RadioResultPastCheck
        {...{
          userDetail: userDetail,
          selectedItem: [selectItem, setSelectItem],
          showParam: [showOld, setShowOld],
        }}
      />
      <PopupOpenRemoteFile
        {...{
          userDetail,
          winState: [
            fileOpener,
            setFileOpener,
            { studyInfo: data?.studyInfo[0] },
          ],
        }}
      />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </MyModal>
  );
}

const PatientContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: start;
  align-items: center;
  margin-block: 2px;
`;

const LabelSpan = styled.div`
  color: #d6d2d0;
  padding-left: 10px;
  padding-right: 10px;
`;

const ItemSpan = styled.div`
  color: #08df5e;
  background-color: #000000;
  /* padding-left: 5px; */
  /* padding-right: 15px; */
  margin-inline: 2px;
  padding-inline: 10px;
  border-radius: 5px;
`;

const TableTitle = styled.div`
  color: #a4e911;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
`;

const TimelineContainer = styled.div`
  background: #121212;
  border-radius: 5px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #222222;
  width: 100%;
  /* margin: 0; */
  border-radius: 5px;
`;

const ParaInfo = styled.div`
  color: #ffff00;
  padding-block: 0px;
  padding-inline: 10px;
  margin: 0px;
`;

const RefrshButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const RefreshButton = styled.div`
  display: flex;
  /* color: #666966; */
  //flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  padding-inline: 5px;
  padding-block: 2px;
  /* background: #221f4e; */
  :hover {
    color: #12e70b;
    background: black;
  }
`;
